/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import Swal from 'sweetalert2'
import { Modal, Button } from 'react-bootstrap'
import { getRequestOptions, postRequestOptions } from '../helpers/Fetchwrapper'
import validationErrorMsg from '../helpers/ValidationErrorMsg'
import showLoader from "../helpers/ShowLoader"
import Select from 'react-select'
import { Table } from 'react-bootstrap-v5';


function AssignedTo({ show, handleClose, companyInfo }) {


	const [users, setUsers] = useState([]);
	const [projects, setProjects] = useState([]);
	const [projectAssignments, setProjectAssignments] = useState({});

	useEffect(() => {
		if (show && companyInfo?.idCompanies) {
			getOwnerships()
			getCompanyAssignments()
		}
	}, [show, companyInfo?.idCompanies])

	const handleAssignmentChange = (projectId, selectedUser) => {
		setProjectAssignments({
			...projectAssignments,
			[projectId]: selectedUser
		});
	}

	const getOwnerships = () => {
		fetch(
			process.env.REACT_APP_API_URL + 'company/assign-to',
			getRequestOptions()
		)
			.then((resp) => {
				return resp.json()
			})
			.then((resp) => {
				let assignedToUsers = resp.data.map((item) => ({
					label: item.name,
					value: item.id,
					id: item.id
				}))
				setUsers(assignedToUsers);
			})
			.catch((error) => {
				console.log(error, 'catch the hoop')
			})
	}

	const getCompanyAssignments = () => {
		fetch(
			`${process.env.REACT_APP_API_URL}company/assignments/${companyInfo.idCompanies}`,
			getRequestOptions()
		)
			.then((resp) => resp.json())
			.then((resp) => {
				if (resp.success) {
					setProjects(resp.data);
					
					// Build initial assignments object
					const initialAssignments = {};
					resp.data.forEach((project) => {
						if (project.id_sr) {
							initialAssignments[project.id_projects] = {
								label: project.user_name,
								value: project.id_sr,
								id: project.id_sr
							};
						}
					});
					setProjectAssignments(initialAssignments);
				}
			})
			.catch((error) => {
				console.log(error, 'catch the hoop')
			})
	}

	const assignedToSave = async (event) => {
		event.preventDefault()
		showLoader();
		
		// Build assignments array
		const assignments = projects.map((project) => ({
			id_projects: project.id_projects,
			id_sr: projectAssignments[project.id_projects]?.id || null
		}));

		const formData = {
			assignments: assignments
		};

		const requestOptions = postRequestOptions(formData)
		try {
			let response = await fetch(
				`${process.env.REACT_APP_API_URL}company/assignments/${companyInfo.idCompanies}`,
				requestOptions
			)
			let respData = await response.json()
			Swal.close();
			if (respData.success === true) {
				const successMsg = respData.successMessage
				Swal.fire({
					icon: 'success',
					title: 'Success',
					text: successMsg,
				})
				handleClose(respData.success)
			} else {
				const errorsMessage = respData.errorMessage || validationErrorMsg(respData.errors).join('<br>')
				Swal.fire({
					icon: 'error',
					title: 'Error',
					html: errorsMessage,
				})
			}
		} catch (error) {
			Swal.close();
			console.log(error, 'catch the hoop')
		}
	}


	return (
		<Modal show={show} onHide={() => handleClose(false)} size="lg">
			<form onSubmit={assignedToSave}>
				<Modal.Header closeButton>
					<Modal.Title>Assign for {companyInfo.companyName}</Modal.Title>
				</Modal.Header>
				<Modal.Body>

					<Table size='sm' bordered hover>
						<thead>
							<tr>
								<th style={{ width: '40%' }}>Project </th>
								<th style={{ width: '60%' }}>Assigned To </th>
							</tr>
						</thead>

						<tbody>

							{projects.map((project, index) => (
								<tr key={'project-' + project.id_projects}>
									<td>{project.project_name}</td>
									<td>
										<Select
											value={projectAssignments[project.id_projects] || null}
											onChange={(selectedUser) => handleAssignmentChange(project.id_projects, selectedUser)}
											options={users}
											isClearable={true}
											placeholder="Select SR..."
											menuPosition="fixed"
										/>										
									</td>									
								</tr>
							))}
							
						</tbody>

					</Table>
					
				</Modal.Body>
				<Modal.Footer>
				
					<button type="submit" className="btn btn-sm btn-primary me-2"><span>  Submit</span></button>
					<Button variant='secondary' size="sm" onClick={() => handleClose(false)}>
						Close
					</Button>
				</Modal.Footer>
			</form>
		</Modal>
	)
}

export default AssignedTo
